



































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IMember } from "@/types/member";

@Component({
  components: {},
})
export default class extends Vue {
  @Action("member/adminGet")
  public getMember!: (id: number) => Promise<void>;

  @Action("member/flipRecruiting")
  public flipRecruiting!: (id: number) => Promise<boolean>;

  @Getter("member/single")
  public member!: IMember;

  @Mutation("member/clear")
  public clear!: () => void;

  public member_id = 0;

  private async created() {
    this.member_id = Number(this.$route.params.member_id);
    this.clear();

    await Promise.all([this.getMember(this.member_id)]);
  }

  public async stoppingChanged() {
    this.flipRecruiting(this.member_id);
  }

  public get items(): {
    title: string;
    icon: string;
    url: string;
    exact: boolean;
  }[] {
    return [
      {
        title: "Dashboard",
        icon: "mdi-folder-account",
        url: `/sales/member/${this.member_id}`,
        exact: true,
      },
      {
        title: "Tickets",
        icon: "mdi-ticket-confirmation",
        url: `/sales/member/${this.member_id}/ticket`,
        exact: false,
      },
      {
        title: "Proposal",
        icon: "mdi-lightbulb-on",
        url: `/sales/member/${this.member_id}/proposal`,
        exact: false,
      },
      {
        title: "Offer",
        icon: "mdi-clipboard-text-multiple",
        url: `/sales/member/${this.member_id}/offer`,
        exact: false,
      },
      {
        title: "Report(comingsoon)",
        icon: "mdi-calendar-month",
        url: `/sales/member/${this.member_id}/ticket`,
        exact: false,
      },
      {
        title: "History(comingsoon)",
        icon: "mdi-tray-full",
        url: `/sales/member/${this.member_id}/ticket`,
        exact: false,
      },
      {
        title: "Setting(comingsoon)",
        icon: "mdi-account-cog",
        url: `/sales/member/${this.member_id}/ticket`,
        exact: false,
      },
    ];
  }
}
